import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supervisores',
  templateUrl: './supervisores.component.html',
  styleUrls: ['./supervisores.component.scss']
})
export class SupervisoresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
